import { CanvasHandler } from "../../../handlers";
import { TextPropertiesEnum } from "../../../enums/TextPropertiesEnum";

class TextProperties {
    public canvasHandler: CanvasHandler;
    public handlers: any

    constructor(canvasHandler: CanvasHandler) {
        this.canvasHandler = canvasHandler;
        this.handlers = {
            [TextPropertiesEnum.CheckFontWeight]: this.updateCheckFontWeight,
            [TextPropertiesEnum.CheckFontStyle]: this.updateCheckFontStyle,
            [TextPropertiesEnum.CheckLeft]: this.updateCheckLeft,
            [TextPropertiesEnum.CheckCenter]: this.updateCheckCenter,
            [TextPropertiesEnum.CheckRight]: this.updateCheckRight,
            [TextPropertiesEnum.CheckJustify]: this.updateCheckJustify,
            [TextPropertiesEnum.Text]: this.updateByKey,
            [TextPropertiesEnum.Linethrough]: this.updateByKey,
            [TextPropertiesEnum.Underline]: this.updateByKey,
            [TextPropertiesEnum.Fill]: this.updateByKey,
            [TextPropertiesEnum.FontSize]: this.updateByKey,
        }
    }

    public updateProperties = (
        selectedItem: any,
        key: string,
        value: any,
        allValues: any,
    ) => {
        const handler = this.handlers[key];

        if (!handler) return;
        
        handler({
            selectedItem,
            value,
            key,
        });
    };

    private updateCheckFontWeight = ({value, selectedItem}: any) => {
        selectedItem.set("fontWeight", value ? "bold" : "normal");
        selectedItem.set("checkFontWeight", value);
    }

    private updateCheckFontStyle = ({value, selectedItem}: any) => {
        selectedItem.set("fontStyle", value ? "italic" : "normal");
        selectedItem.set("checkFontStyle", value);
    }

    private updateCheckLeft = ({value, selectedItem}: any) => {
        selectedItem.set("textAlign", value ? "left" : "");
        if (value) {
            selectedItem.set({
                checkCenter: false,
                checkRight: false,
                checkJustify: false
            })
        }
    }

    private updateCheckCenter = ({value, selectedItem}: any) => {
        selectedItem.set("textAlign", value ? "center" : "");
        if (value) {
            selectedItem.set({
                checkLeft: false,
                checkRight: false,
                checkJustify: false
            })
        }
    }

    private updateCheckRight = ({value, selectedItem}: any) => {
        selectedItem.set("textAlign", value ? "right" : "");
        if (value) {
            selectedItem.set({
                checkLeft: false,
                checkCenter: false,
                checkJustify: false
            })
        }
    }

    private updateCheckJustify = ({value, selectedItem}: any) => {
        selectedItem.set("textAlign", value ? "justify" : "");
        if (value) {
            selectedItem.set({
                checkLeft: false,
                checkCenter: false,
                checkRight: false
            })
        }
    }

    private updateByKey = ({value, selectedItem, key}: any) => {
        selectedItem.set(key, value);
    }

}

export default TextProperties;